<template>
    <div
        class="text-[var(--foreground)] dark:bg-[#0D141E] dark:bg-[linear-gradient(109.63deg,#030226_3.67%,#06143D_83.91%)] bg-[#FCFDFF] overflow-hidden relative z-30">
        <div class=" dark:bg-[linear-gradient(90deg,#000000_-35.94%,rgba(6,1,46,0)_51.53%,#000000_129.81%)]">

            <WrOfficialPartnerHeader
                append-class="dark:!bg-none dark:!bg-[#09040C] dark:!border-[#250243]" />
            <WrHeader
                append-class="dark:!bg-none dark:!bg-[#09040C] dark:!border-[#250243]" />

            <WrBreadCrumb class="mt-6 z-30 relative" />

            <div class="pt-0 mt-0 max-sm:mt-1">
                <main id="main-content">
                    <slot />
                </main>
            </div>

            <section class="grid place-items-center z-10 relative pt-10 max-md:px-4 overflow-hidden" id="mask-section">
                <WrAnimatedImg />
            </section>
            <WrFooter />
        </div>
    </div>

</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
const WrAnimatedImg = defineAsyncComponent(
    () => import("~/components/molecules/WrAnimatedImg.vue")
);
const WrFooter = defineAsyncComponent(
    () => import("~/components/molecules/WrFooter.vue")
);
const WrHeader = defineAsyncComponent(
    () => import("~/components/molecules/WrHeader.vue")
);
const WrBreadCrumb = defineAsyncComponent(
    () => import("~/components/molecules/WrBreadCrumb.vue")
);
const WrOfficialPartnerHeader = defineAsyncComponent(
    () => import("~/components/molecules/WrOfficialPartnerHeader.vue")
);
const hydrated = ref(false);
onMounted(() => {
    hydrated.value = true;
});
</script>
